var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{attrs:{"to":{name: 'integrations-new-webhook' }}},[_c('b-button',{attrs:{"icon-left":"webhook"}},[_vm._v("Webhook")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }